import { render, staticRenderFns } from "./presentacion.vue?vue&type=template&id=1cbeb7ac&"
import script from "./presentacion.vue?vue&type=script&lang=js&"
export * from "./presentacion.vue?vue&type=script&lang=js&"
import style0 from "./presentacion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports